<template>
  <v-parallax src="http://d-mebius.com/fusigi_na_game2/img/bg.jpg">
    <ToplogoImage />
    <v-container class="my-16">
      <v-sheet
        style="max-width: 1280px; letter-spacing: 0.1em; line-height: 2em;"
        class="mx-auto my-12 pa-5 bg-white rounded-xl"
        border="lg opacity-12"
      >
        <p>
          「ふしぎなゲーム祭り」はゲームの試遊と物販を中心にしたゲームイベントです。
        </p>
        <p class="my-5">
          ファミコンショップマリオ様からはじまった<span class="bold"
            >「ふしぎな」</span
          >ご縁により、 新しい体験のできる<span class="bold">「ふしぎな」</span
          >ラインナップが勢揃い！
        </p>
        <p>
          遊んだその場で ゲームやグッズが買える<span class="bold"
            >「ふしぎな」</span
          >イベントになっております。
        </p>
      </v-sheet>

      <AppNews />
    </v-container>
  </v-parallax>
</template>

<script>
  import AppNews from "./AppNews.vue";
  import ToplogoImage from "./ToplogoImage.vue";

  export default {
    name: "App",
    components: {
      AppNews,
      ToplogoImage,
    },
  };
</script>

<style scoped>
  .bold {
    color: #ff1744;
    font-weight: bold;
  }
</style>
